class SearchPopdown extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      details: 'details',
      popdown: '[data-popdown]',
      popdownClose: '[data-popdown-close]',
      popdownToggle: '[data-popdown-toggle]',
      scrollContainer: '[data-popular-searches]',
      scrollContainerWithResult: '[data-search-results]',
      input: 'input:not([type="hidden"])',
      overlay: '[data-site-main-dimmer]'
    };

    this.popdown = this.querySelector(this.selectors.popdown);
    this.popdownContainer = this.querySelector(this.selectors.details);
    this.popdownToggle = this.querySelector(this.selectors.popdownToggle);
    this.popdownClose = this.querySelector(this.selectors.popdownClose);
    this.overlay = document.querySelector(this.selectors.overlay);
    this.scrollContainer = document.querySelector(this.selectors.scrollContainer);

    this.openers = new Set();
    this.disableAnimations = ('reduceAnimations' in document.body.dataset);
  }

  connectedCallback() {
    this.popdownContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.popdownClose.addEventListener('click', this.close.bind(this));
    this.popdownToggle.addEventListener('click', this.onPopdownToggleClick.bind(this));
    // this.popdownToggle.setAttribute('role', 'button');
    this.popdown.addEventListener('transitionend', (event) => {
      if (event.propertyName == 'visibility' && this.popdownContainer.hasAttribute('open') && this.popdownContainer.getAttribute('open') == 'false') {
        this.popdownContainer.removeAttribute('open');
      }
    });
  }

  onPopdownToggleClick(event) {
    event.preventDefault();
    event.target.closest(this.selectors.details).hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target)) this.close();
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.scrollContainerWithResult = document.querySelector(this.selectors.scrollContainerWithResult);

    event.target.closest(this.selectors.details).setAttribute('open', '');
    document.body.addEventListener('click', this.onBodyClickEvent);

    // Safari opening transition fix
    requestAnimationFrame(() => {
      let searchPopdownElem = event.target.closest(this.selectors.details).querySelector('.search-popdown');

      event.target.closest(this.selectors.details).setAttribute('open', 'true');
      searchPopdownElem.setAttribute('tabindex', '0')
      searchPopdownElem.setAttribute('aria-hidden', 'false');
      Theme.trapFocus(this.popdown,  this.popdown.querySelector(this.selectors.input));
    });

    this.overlay.setAttribute('data-animation-state', 'open')

    bodyScrollLock.disableBodyScroll(this.scrollContainer);
  }

  close() {
    let searchPopdownElem = this.popdownContainer.querySelector('.search-popdown');

    Theme.removeTrapFocus();
    this.popdownContainer.setAttribute('open', 'false');
    searchPopdownElem.setAttribute('tabindex', '-1');
    searchPopdownElem.setAttribute('aria-hidden', 'true');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
    this.overlay.setAttribute('data-animation-state', 'close');

    bodyScrollLock.clearAllBodyScrollLocks();
  }
}

customElements.define('header-search-popdown', SearchPopdown);
